import styles from "./styles";
import SignIn from "../../../../Diathrive/src/containers/SignIn";
import OnBoardingExperience from "../../../../Diathrive/src/containers/OnBoardingExperience";
import { tID } from "../../../../Diathrive/src/utils/TestIdHelper";
import LogoHeader from "../../components/elements/LogoHeader";
import MobileAppStoreLinks from "../../components/elements/MobileAppStoreLinks";
import CommonStyles from "../../../../Diathrive/src/utils/CommonStyles";
import { useNavigate } from "react-router-dom";

export default function LoginFlow() {
  let navigate = useNavigate();
  return (
    <>
      <div
        data-testid={tID("LoginFlow-div-Container")}
        style={styles.container}
      >
        <div style={styles.uniqueIdForm}>
          <LogoHeader />
          <div style={styles.formContainer}>
            <SignIn navigation={navigate} />
          </div>
          <MobileAppStoreLinks
            containerStyle={CommonStyles.mb_52}
            testIdScreenName="LoginFlow"
          />
        </div>
        <div style={styles.previewImage}>
          <OnBoardingExperience />
        </div>
      </div>
    </>
  );
}
